import {URL_BASE_API } from '../configs/urlConfigs';

import service from './api';

export const feedbackFilterEventsList = (request) => {     
    let ENDPOINT = URL_BASE_API+'events/feedback-filter-events/?is_event=1'; 
    if(request.data && request.data.clientsIds && request.data.clientsIds.length) {
        let clientsIds = JSON.stringify(request.data.clientsIds);
        ENDPOINT = URL_BASE_API+'events/feedback-filter-events/?is_event=1&clients='+clientsIds; 
    } 
    else if(request.data && request.data.affiliateIds && request.data.affiliateIds.length) {
        let affiliateIds = JSON.stringify(request.data.affiliateIds);
        ENDPOINT = URL_BASE_API+'events/feedback-filter-events/?is_event=1&affiliates='+affiliateIds; 
    } 

    return service.get(ENDPOINT);  
}; 

export const feedbackFilterReviewersList = (request) => {     
    let ENDPOINT = URL_BASE_API+'events/feedback-filter-reviewers/?is_event=1'; 

    if(request.data && request.data.clientsIds && request.data.clientsIds.length) {
        let clientsIds = JSON.stringify(request.data.clientsIds);
        ENDPOINT = URL_BASE_API+'events/feedback-filter-reviewers/?is_event=1&clients='+clientsIds; 
    } 
    else if(request.data && request.data.affiliateIds && request.data.affiliateIds.length) {
        let affiliateIds = JSON.stringify(request.data.affiliateIds);
        ENDPOINT = URL_BASE_API+'events/feedback-filter-reviewers/?is_event=1&affiliates='+affiliateIds; 
    } 

    return service.get(ENDPOINT);  
}; 


